import React from 'react';
import { Button, Stack } from '@mui/material';
import { MdArrowBack, MdArrowForward } from 'react-icons/md';

const getPageRange = (current, total) => {
  const delta = 1;
  const range = [];
  const left = Math.max(2, current - delta);
  const right = Math.min(total - 1, current + delta);

  range.push(1);

  if (left > 2) {
    range.push('...');
  }

  for (let i = left; i <= right; i++) {
    range.push(i);
  }

  if (right < total - 1) {
    range.push('...');
  }

  if (total > 1) {
    range.push(total);
  }

  return range;
};

const Pagination = ({ currentPage, totalPages, handlePageChange, loading = false }) => {
  const handlePrevious = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1);
    }
  };

  const pageRange = getPageRange(currentPage, totalPages);

  return (
    <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
      <Button
        variant="outlined"
        size="small"
        startIcon={<MdArrowBack />}
        onClick={handlePrevious}
        disabled={currentPage === 1 || loading}
      />

      {pageRange.map((page, index) => (
        <Button
          key={index}
          variant={page === currentPage ? 'contained' : 'outlined'}
          size="small"
          onClick={() => typeof page === 'number' && handlePageChange(page)}
          disabled={loading || page === '...'}
        >
          {page}
        </Button>
      ))}

      <Button
        variant="outlined"
        size="small"
        endIcon={<MdArrowForward />}
        onClick={handleNext}
        disabled={currentPage === totalPages || loading}
      />
    </Stack>
  );
};

export default Pagination;
